import { apiPathFunc } from "@api/util/apiPathFunc";

import type { IExtractParams } from "@routes";

const pathBase = `/filters/product-plan/`;

export type IPathBaseParam = IExtractParams<typeof pathBase>;

export const productPlan = {
  get: apiPathFunc(pathBase),
} as const;
